import ContentSections from './ContentSections'

export default ContentSections
